{
  "page_count": "/ {n, plural, one{# oldal} other{# oldalak}}"
}
